import React from 'react'
import styled from 'styled-components'
import { LucaIcon } from '../LucaIcon'

type Props = {
  label: string
  onClick?: () => void
  disabled?: boolean
  title?: string
  className?: string
}

/**
 * Reusable Luca suggestion chip (mockup: brand icon + label pill).
 * Pair with `useOpenLucaWithPrompt` to open the widget and send the label as a prompt.
 */
export const LucaPromptChip: React.FC<Props> = ({ label, onClick, disabled, title, className }) => (
  <Chip
    type="button"
    className={className}
    onClick={onClick}
    disabled={disabled}
    title={title ?? label}
  >
    <LucaIcon size={13} style={{ color: '#1b98f5' }} />
    <span>{label}</span>
  </Chip>
)

export const LucaPromptChipRow = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

const Chip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  flex: none;
  height: 30px;
  padding: 0 12px 0 9px;
  border: none;
  border-radius: 1.5rem;
  background: rgba(27, 152, 245, 0.08);
  color: #0b3d62;
  font-size: 12.5px;
  font-weight: 500;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: rgba(27, 152, 245, 0.16);
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 1px;
  }
`
